import { Provider } from "jotai";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";

import { ReactQueryProvider } from "@common/react-query-provider";

import { TooltipProvider } from "@/components/ui/tooltip"

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReactQueryProvider>
      <Provider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
          enableColorScheme
        >
          <Toaster theme="system" />
          <TooltipProvider>{children}</TooltipProvider>
        </ThemeProvider>
      </Provider>
    </ReactQueryProvider>
  );
};
